import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/ResourceLibraryEdit.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import ResourceLibraryView from "./ResourceLibraryView";

const ResourceLibraryEdit =()=>{
      
 
        const initialFormData = {
            title:'',
            field_folder:'',
            summary: '',
            body: '',
            field_url:'',
            field_file_attachments:[],
            removed_fids:[],
            field_meta_title:'',
            field_meta_keywords:'',
            field_meta_description:''
        };
        const [formData,setFormData] =useState(initialFormData);
        const [isLoading, setIsLoading] = useState(true);
        const [toggle, setToggle] = useState(2);
        const [errors, setErrors] = useState({});
        const [selectedFiles, setSelectedFiles] = useState([]);
        const [uploadedFiles, setUploadedFiles] = useState([]);
        const [backenduploadedFiles, setBackendUploadedFiles] = useState([]);
        const [fileInputKey, setFileInputKey] = useState(0);
        const [errorMessage, setErrorMessage] = useState('');
        const [showSummary, setShowSummary] = useState(false);
        const [useRichEditor, setUseRichEditor] = useState(true);
        const [savedData, setSavedData] = useState(initialFormData);
        const [PreviewFields, setPreviewFields] = useState(false);
        const [viewChanges, setViewChanges] = useState(false);
        const [originalData, setOriginalData] = useState(null);
        const [formDataSnapshot, setFormDataSnapshot] = useState(null);
        const [previewData, setPreviewData] = useState(null);
        const [detailedview, setDetailedView] = useState({});
        const [folders, setFolders] = useState({});
        const [disabled, setDisabled] = useState(false);
        const [buttontext, setButtonText] = useState("Save");

        const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

        const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
        const domainName = window.location.hostname;

            const location  = useLocation();
            const drupal_uid = localStorage.getItem('drupal_uid');
            const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
            var loggedin_domain = drupal_domain_url;
            if(localStorage.getItem('loggedin_domain')) {
            loggedin_domain = localStorage.getItem('loggedin_domain');
            } 
            // var {uid} = useParams();
            // var {username} = useParams();
            // if(location.state) {
            // uid = location.state;
            // }
            const {tab} = useParams();
            const loggedin_uid = localStorage.getItem('uid');
            const navigate = useNavigate();
            const app_url = configData.APP_URL;
            const domain_url = configData.DOMAIN_URL;
            const {rid} = useParams();

            function updateToggle(id){
                setToggle(id);
        
                if(id == 1) { 
                  navigate(
                    "/resource_library/"+rid+"/view"
                  );
                }
                if(id == 2) { 
                navigate(
                    "/resource_library/"+rid+"/edit"
                );
                }
                
            }

    const getPageTitle = () => {
      const title = originalData?.title || "";

      if (toggle === 1) {
        return title ? title : "Resource Library";
      } else if (toggle === 2) {
        return title ? `Edit Resource Library ${title}` : "Edit Resource Library";
      }

      return "Resource Library"; // default fallback
    };

    const getPageHeading = () => {
      const title = originalData?.title || "";

      if (toggle === 2) {
        return (
          <>
            <em>Edit Resource Library</em> {title}
          </>
        );
      }

      return null;
    };

    useEffect(() => {
      Promise.all([
        retrieveresourcelibrary(),
        getresourcelibraryfolderlist(),
        getuserloggedinroles()
      ]).then(() => {
     
        setIsLoading(false);
        if(tab == "view") {
          setToggle(1);
        }
        if(tab == "edit") {
          setToggle(2);
        }
      })
        
    } ,[tab]);

    async function getuserloggedinroles() {
   
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       
  }      
    
       async function  retrieveresourcelibrary() {
            const response = await fetch(
            app_url+'smwwagency/retrieveresourcelibrary?id='+rid,
                {
                    method: "GET",
            
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                  const updatedForm = {
                    title: responsedata.data.result.title,
                       body: responsedata.data.result.body,
                       field_folder: responsedata.data.result.field_folder_id,
                       field_url:responsedata.data.result.field_url,
                       field_meta_title:responsedata.data.result.field_meta_title,
                       field_meta_keywords:responsedata.data.result.field_meta_keywords,
                      field_meta_description:responsedata.data.result.field_meta_description,
                      field_file_attachments: responsedata.data.result.field_file_attachments?.name || '',
                    }
              setBackendUploadedFiles(responsedata.data.result.field_file_attachments);
              setOriginalData(updatedForm);
              setFormData(updatedForm);
    
            }
        }
         async function getresourcelibraryfolderlist() {
    
        try {
      
            const response = await fetch(
                app_url+'smwwagency/getresourcelibraryfolderlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setFolders(responsedata.data.result);
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }
             const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };
    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };

        const handlePreviewRedirect = () => {
            window.location.href = '/resource_library?tid='+previewData.field_folder_id;
        };
const getFolderLabel = (value) => {
  if (!Array.isArray(folders)) return value;

  const match = folders.find(f => String(f.value) === String(value));

  return match ? match.label : value;
};

const backendFiles = Array.isArray(backenduploadedFiles)
  ? backenduploadedFiles
  : [];

const handlePreviewClick = () => {
  setViewChanges(false);
  const {
     title,
     field_folder,
     summary,
     body,
     field_url,
     field_file_attachments,
     field_meta_title,
     field_meta_keywords,
     field_meta_description
  } = formData;


  const newErrors = {};
  if (!title.trim()) {
    newErrors.title = "Title field is required.";
  }
 

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    setPreviewFields(false);
    return;
  }
  const bodyHtml = body || '';
  const hasSummary = summary && summary.trim() !== '';
  let trimmedHtml = '';

  if (hasSummary) {
  trimmedHtml = summary;
} else if (bodyHtml.includes('<!--break-->')) {
  trimmedHtml = bodyHtml.split('<!--break-->')[0];
} else {
  const tmp = document.createElement('div');
  tmp.innerHTML = bodyHtml;
  const plainText = (tmp.textContent || tmp.innerText || "").trim();

 trimmedHtml = '';
}

 

  setPreviewData({
    title,
    field_folder_id: formData.field_folder,
    field_folder: getFolderLabel(formData.field_folder),
    summary: hasSummary ? summary : '',
    body: bodyHtml,
    trimmed: trimmedHtml,  
    field_url,
    // field_file_attachments,
    field_file_attachments: [
      ...backendFiles,
      ...uploadedFiles
    ],
    field_meta_title,
    field_meta_keywords,
    field_meta_description
  });
  window.scrollTo(0, 0);
  setErrors({});
  setPreviewFields(true);  
};
const handleViewChangesClick = () => {
  setPreviewFields(false);
  const newErrors = {};

  if (!formData.title.trim()) {
    newErrors.title = 'Title field is required.';
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).some(key => newErrors[key])) {
    setViewChanges(false); // Don't show view changes
    return;
  }

  setViewChanges(true);
  
const normalizeFiles = (filesArray = []) =>
  Array.isArray(filesArray)
    ? filesArray.map(f => ({
        name: f.name,
        size: f.size,
        url: f.url || null,
        fid: f.fid || null
      }))
    : [];

setFormDataSnapshot({
  ...formData,
  field_file_attachments: normalizeFiles([
    ...backendFiles,
    ...uploadedFiles,
  ]),
});

  setOriginalData(prev => ({
    ...prev,
    field_file_attachments: normalizeFiles(backendFiles),
  }));

  window.scrollTo(0, 0);
};


    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;


        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };
      

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const maxSize = 128 * 1024 * 1024;

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);

        const allowedMimeTypes = [
            'text/plain',
            'application/msword',
            'application/pdf',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv',
            'text/html',
            'image/gif',
            'image/png',
            'image/jpeg',
            'video/mp4',
            'video/quicktime',
            'video/x-flv'
        ];

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidSize = file.size <= maxSize;
            const isValidType = allowedMimeTypes.includes(file.type);

            if (isValidSize && isValidType) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setErrorMessage(
            `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded.
              Only files with the following extensions are allowed: txt, doc, pdf, xls, docx, xlsx, csv, html, htm, gif, png, jpg, mp4, mov, flv.`
            );
            setFileInputKey(prev => prev + 1);
            setSelectedFiles([]);
        } else {
            setErrorMessage('');
            setSelectedFiles(validFiles);
        }
    };


    const handleUpload = () => {
        // Validate selected files
        const newFiles = selectedFiles.filter(file => {
         
            const isValidSize = file.size <= maxSize;
            return isValidSize;
        });

        setUploadedFiles(prev => [...prev, ...newFiles]);
        /* setFormData(prev => ({
        ...prev,
        field_file_attachments: [...prev.field_file_attachments, ...newFiles]
    })); */
        setErrorMessage('');
        setSelectedFiles([]);
        
        // Clear input value by resetting key prop or manually
        // document.getElementById('edit-field-agent-contract').value = '';
        setFileInputKey(prev => prev + 1);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };
    const removeBackendFile = (index,removed_fid) => {
        setBackendUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    };
           const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData(prev => ({ ...prev, [name]: value }));
        };
    
        const validateForm = () => {
            const newErrors = {};
            if (!formData.title.trim()) {
                newErrors.title = "Title is required.";
            }
            return newErrors;
        };
         const inputStyle = {
  title: {
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
 
 };
const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validateForm();
  setErrors(validationErrors);
  setViewChanges(false);
  setPreviewFields(false);
  setUploadedFiles([]);
  const finalBody = cleanHtmlOutput(formData.body);
  
  setDisabled(true);
  setButtonText("Saving..."); 
  if (Object.keys(validationErrors).length === 0) {
     const postData = new FormData();
        const updatedFormData = {
            ...formData,
           body: finalBody,
           id:rid
        };
        postData.append('file', selectedFiles);
        uploadedFiles.forEach(file => postData.append('files[]', file));
        // postData.append('formData', JSON.stringify(formData));
        postData.append('formData', JSON.stringify(updatedFormData));
         const response = await fetch(app_url+'smwwagency/putresourcelibrary', {
            method: 'POST',
            body: postData,
        });
        const data = await response.json();
      if(data.data.msg == "Success") {  
        setButtonText("Save");
        setDisabled(false);
        navigate('/resource_library/'+data.data.id+'/view', { state: { message: data.data.result } });
      } 
    // setSavedData(updatedFormData);
    // alert("Changes saved successfully!");
    console.log("Submitted data:", updatedFormData);
  }
};

   const handleDelete = async () => {
  if (window.confirm("Are you sure you want to delete?")) {
    const response = await fetch(
        app_url+'smwwagency/deleteresourcelibrary?id='+rid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            navigate('/resource_library', { state: { message: responsedata.data.result } });
           
        }
  }
};
    return(
         <>
            {isLoading ? (
                <Loading />
            ) : (
        <div id="main" className="resource-library-edit-main">
             <Helmet>
                <title>
                    {getPageTitle()}
                </title>
            </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                  <>
                    <h1 className="edit-task-title">{getPageHeading()}</h1>
                  </>
                   {toggle === 2 && (
                    <>
                        
                    </>
                )}
                <>
                  {( userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                    <ul className="tabs primarya">
                      <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                        <a style={{cursor: "pointer"}}>View</a>
                      </li>
                    
                      <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                        <a style={{cursor: "pointer"}}>Edit</a>
                      </li>
                      {/* )} */}
                    </ul>
                  }
                </>
                        <div  className= {toggle === 1? "show-content" : "content"}>
                            <ResourceLibraryView />
                        </div>

{( userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                       <div  className= {toggle === 2? "show-content" : "content"}>
                         {viewChanges && (
<div className='diff-table-wrapper'>
  <table className="diff-table">
  <colgroup>
    <col className="diff-marker" />
    <col className="diff-content" />
    <col className="diff-marker" />
    <col className="diff-content" />
  </colgroup>
  <thead>
    <tr>
      <th colSpan="2">Original</th>
      <th colSpan="2">Changes</th>
    </tr>
  </thead>
  <tbody>
    {!formDataSnapshot || !originalData ? (
      <tr className="no-changes">
        <td className="diff-section-title" colSpan="4">No visible changes</td>
      </tr>
    ) : (
      (() => {
        const diffs = [];

    
        const compareField = (label, oldValue = '', newValue = '') => {
  if (oldValue === newValue) return null;

  const oldLines = (oldValue ?? '').split('\n');
  const newLines = (newValue ?? '').split('\n');
  const maxLines = Math.max(oldLines.length, newLines.length);

  const rows = [
    <tr className="diff-section-title" key={`${label}-title`}>
      <td colSpan="4">Changes to <em>{label}</em></td>
    </tr>
  ];

  for (let i = 0; i < maxLines; i++) {
    const oldLine = (oldLines[i] || '').trim();
    const newLine = (newLines[i] || '').trim();

    if (oldLine !== newLine) {
      const oldWords = oldLine.split(/\s+/);
      const newWords = newLine.split(/\s+/);
      const maxWords = Math.max(oldWords.length, newWords.length);

      const renderWords = (wordsA, wordsB, isOld) =>
        wordsA.map((word, idx) => {
          const matchingWord = wordsB[idx] || '';
          const changed = word !== matchingWord;

          return (
            <span
              key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
              style={changed ? {
                color: isOld ? 'red' : 'red',
                borderRadius: '4px',
                padding: '0 3px',
                fontWeight:'bold'
              } : {}}
            >
              {word}
              {' '}
            </span>
          );
        });

      rows.push(
        <tr key={`${label}-${i}`}>
          <td style={{width:"2px"}}><span>-</span></td>
          <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
          <td style={{width:"2px"}}><span>+</span></td>
          <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
        </tr>
      );
    }
  }

  return rows;
};

// const compareFiles = (label, oldFiles = [], newFiles = []) => {
//   const oldList = oldFiles.map(f => f.name).join(', ');
//   const newList = newFiles.map(f => f.name).join(', ');

//   if (oldList !== newList) {
//     return [`${label} changed: ${oldList} → ${newList}`];
//   }

//   return [];
// };
const compareFiles = (label, oldFiles = [], newFiles = []) => {
  const oldList = Array.isArray(oldFiles)
    ? oldFiles.map(f => f.name).join(', ')
    : '';

  const newList = Array.isArray(newFiles)
    ? newFiles.map(f => f.name).join(', ')
    : '';

  // If no difference, return an empty array (safe + iterable)
  if (oldList === newList) {
    return [];
  }
  // Otherwise return whatever diff UI compareField creates
  return [compareField(label, oldList, newList)];
};
const oldFolderValue = originalData?.field_folder ?? null;
const newFolderValue = formDataSnapshot?.field_folder ?? null;

const oldLabel = getFolderLabel(oldFolderValue);
const newLabel = getFolderLabel(newFolderValue);

console.log("folders:", folders);
console.log("old:", originalData.field_folder, "→", oldLabel);
console.log("new:", formDataSnapshot.field_folder, "→", newLabel);

        diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));
        // diffs.push(...(compareField('Folder', originalData.field_folder, formDataSnapshot.field_folder) || []));
        if (oldFolderValue != null || newFolderValue != null) {
          diffs.push(...(compareField('Folder', oldLabel, newLabel) || []));
        }
        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));       
        diffs.push(...(compareField('URL', originalData.field_url, formDataSnapshot.field_url) || []));
        // diffs.push(...(compareField('File Attachments', originalData.field_file_attachments, formDataSnapshot.field_file_attachments) || []));
        diffs.push(...compareFiles(
  'File Attachments',
  originalData.field_file_attachments,
  formDataSnapshot.field_file_attachments
));
        diffs.push(...(compareField('Meta Title', originalData.field_meta_title, formDataSnapshot.field_meta_title) || []));
        diffs.push(...(compareField('Meta Keywords', originalData.field_meta_keywords, formDataSnapshot.field_meta_keywords) || []));
        diffs.push(...(compareField('Meta Description', originalData.field_meta_description, formDataSnapshot.field_meta_description) || []));  
     
     

        return diffs.length > 0 ? diffs : (
          <tr className="no-changes">
            <td className="diff-section-title" colSpan="4">No visible changes</td>
          </tr>
        );
      })()
    )}
  </tbody>
</table>
</div>
)}
{PreviewFields && (
  <>
    <div
      className="messages status"
      style={{
        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
        backgroundPosition: '10px 10px',
      }}
    >
      The trimmed version of your post shows what your post looks like when promoted
      to the main page or when exported for syndication.
      <span>
        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
        fine-tune where your post gets split.
      </span>
    </div>

    <div className="preview-container">
      {/* Trimmed version */}
      <div className="preview-trimmed">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview trimmed version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            <a href={"/resource_library/"+rid+"/view"}>{previewData?.title}</a>
          </h2>

          {/* <div className="email-teaser-block1">
            <div className="email-teaser-block2"> */}
              {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
  <div
    className="preview-body-content"
    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
  />
              )}
            {/* </div>
          </div> */}

          <div className="read-more-link">
            <a href={"/resource_library/"+rid+"/view"}>Read more</a>
          </div>
        </div>
      </div>

      {/* Full version */}
      <div className="preview-full">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview full version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            {/* <strong>Body:</strong> */}
          </h2>

          {/* <div className="email-teaser-block1"> */}
            {/* <div className="email-teaser-block2"> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: previewData.body || '',
                }}
              />
              <div className="email-meta">
                 {previewData.field_folder && (
  <p><strong>Folder:</strong> <a onClick={handlePreviewRedirect} style={{cursor: "pointer"}}>{previewData.field_folder}</a></p>)}
   {previewData.field_url && (
  <p><strong>URL:</strong> {previewData.field_url}</p>)}
  {previewData.field_file_attachments && previewData.field_file_attachments.length > 0 && (
  <>
    <strong>File Attachments:</strong>
    <ul>
      {previewData.field_file_attachments.map((file, idx) => (
        <li key={idx}>
          {file.name} ({(file.size / 1024).toFixed(2)} KB)
        </li>
      ))}
    </ul>
  </>
  )}

   {previewData.field_meta_title && (
  <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
   {previewData.field_meta_keywords && (
  <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
   {previewData.field_meta_description && (
  <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}
</div>

            {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  </>
)}
                <div className="resource-library-edit-container">
                             {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className="form-item">
                                <label htmlFor="create-agent-message-title">
                                    Title  
                                    <span className="form-required" title="This field is required.*">*</span>
                                </label>
                                <input 
                                    className="create-agent-message-title-field" 
                                    type="text" 
                                    id="create-agent-message-title" 
                                    name="title" 
                                    maxLength={100}
                                    onChange={handleChange} 
                                     value={formData.title}
                                    style={inputStyle.title}
                            
                                />
                                    {/* {errors.title && (
                                    <div className="form-error">{errors.title}</div>
                                )} */}
                            </div>
                            <div className="form-item">
                                <label htmlFor="edit-field-folder-und">Folder</label>
                                    <select
                                        id="edit-field-folder-und"
                                        name="field_folder"
                                        className="form-select"
                                        value={formData.field_folder}
                                        onChange={handleChange}
                                    >
                                        {/* Loop through the folders array and render options dynamically */}
                                        {/* {folders.map((folder) => ( */}
                                        {Array.isArray(folders) && folders.map(folder => (
                                        <option key={folder.value} value={folder.value}>
                                            {folder.label}
                                        </option>
                                        ))}
                                    </select>
                            </div>
                            <div className="">
                                <div>
                                    {showSummary && (
                                        <div className="form-item">
                                            <label htmlFor="create_summary">
                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                            </label>
                                            <>
                                                <>
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.summary} 
                                                        // onChange={e => onEditorChange('summary', e.target.value)} 
                                                        onChange={value => onEditorChange('summary', value)}
                                                    />
                                                </>
                                            </>
                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                        </div>
                                    )}
                            
                                    <div className="form-item">
                                        <label htmlFor="create_body">
                                            Body 
                                            {!showSummary && (
                                                <span>
                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                        Edit Summary
                                                    </a>)
                                                </span>
                                            )}
                                        </label>
                                        <>
                                            {useRichEditor ? (
                                                <> 
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)}
                                                        // onChange={value => onEditorChange('body', value)}
                                                         onChange={handleEditorChange}

                                                    />  
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                        Switch to plain text editor
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <textarea
                                                        id="create_body"
                                                        rows="20"
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)} 
                                                        onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) }
                                                    />
                                                    <div 
                                                        className="grippie" 
                                                        style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                    >
                                                    </div>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                        Switch to rich text editor
                                                    </a>
                                                </>
                                            )}
                                        </>
                                    </div>
                                     <div className="form-item">
                                    <label htmlFor="edit-field-url">URL</label>
                                    <input
                                        className=""
                                        type="text"
                                        id="edit-field-url"
                                        name="field_url"
                                        value={formData.field_url}
                                        onChange={handleChange}
                                        size="60"
                                        maxLength="60"
                                    />
                                    </div>
                                    <p>File Attachments</p>
                                    <div className="fieldset-wrapper">
    {(uploadedFiles?.length > 0 || backenduploadedFiles?.length > 0) && (
        <table className="" style={{fontSize:"14px", width:"90%"}}>
            <thead>
                <tr style={{textAlign:"left"}}>
                <th>File information</th>
                <th>Operations</th>
                </tr>
            </thead>
            <tbody style={{backgroundColor: "#eee", borderBottom: "1px solid #ccc"}}>
                {uploadedFiles?.length > 0 && uploadedFiles.map((file, index) => (
                <tr key={index}>
                    <td>
                    <span className="file">
                        <img
                            className="file-icon"
                            alt="File icon"
                            src={getFileIcon(file.name)}
                            style={{ marginRight: '8px' }}
                        />
                        <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                        {file.name}
                        </a>
                    </span>
                    <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                    </td>
                    <td>
                    <button
                        type="button"
                        className="form-submit"
                        onClick={() => removeFile(index)}
                    >
                        Remove
                    </button>
                    </td>
                </tr>
                ))}
                 {backenduploadedFiles?.length > 0 && backenduploadedFiles.map((file, index) => (
                <tr key={index}>
                    <td>
                    <span className="file">
                        <img
                            className="file-icon"
                            alt="File icon"
                            src={getFileIcon(file.name)}
                            style={{ marginRight: '8px' }}
                        />
                        <a href={file.url} target="_blank" rel="noreferrer">
                        {file.name}
                        </a>
                    </span>
                    <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                    </td>
                    <td>
                    <button
                        type="button"
                        className="form-submit"
                        onClick={() => removeBackendFile(index,file.fid)}
                    >
                        Remove
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
        </table>
    )}
    
    {errorMessage && (
        <div 
            className="set-message-error" 
            style={{ 
                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                padding: "10px 10px 10px 50px",
                width: "90%",
            }}
        >
            {errorMessage}
        </div>
    )}

    <div className="form-item">
        <label htmlFor="edit-field-agent-contract">Add a new file</label>
        <div>
            <input
                type="file"
                id="edit-field-agent-contract"
                name="field_file_attachments"
                className="form-file"
                multiple
                onChange={handleFileInputChange}
                key={fileInputKey}
                style={{width: "auto"}}
            />
            <button type="button" onClick={handleUpload} disabled={selectedFiles.length === 0} className="form-submit">
                Upload
            </button>
        </div>
        <div className="description" style={{fontSize:".85em"}}>
            Files must be less than <strong>128 MB</strong>.<br />
            Allowed file types: <strong>txt doc pdf xls docx xlsx csv html htm gif png jpg mp4 mov flv</strong>.
        </div>
    </div>

</div>
                 <div className="form-item -field-meta-title">
          <label htmlFor="meta_title">Meta Title</label>
          <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
           onChange={handleChange}  
        /> 
      </div>
      <div className="form-item field-meta-keywords">
          <label htmlFor="meta_keywords">Meta Keywords</label>
          <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
             onChange={handleChange}
          /> 
      </div>
              <div className="form-item  fieldmeta-description">
          <label>Meta Description</label>
          <textarea
            name="field_meta_description"
            value={formData.field_meta_description}
            onChange={handleChange}
            
          />
                                <div className="grippie" style={{
    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
  }}>   
  </div>

        </div>
                                </div>
                            </div>
                            <div className="form-actions form-wrapper" id="create-actions">
                                {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                                <button type="submit" className="form-submit" disabled={disabled}>{buttontext}</button>&nbsp;&nbsp;
                               <input 
                                          type="button" 
                                          id="edit-preview"  
                                          value="Preview" 
                                          className="form-submit" 
                                          onClick={()=> {
                                          handlePreviewClick();
                                          // window.scrollTo({ top: 0, behavior: 'smooth' });
                                          }}
                                        />&nbsp;&nbsp;
                                        <input
                                          type="button"
                                          id="edit-task-preview-changes"
                                          value="View changes"
                                          className="form-submit"
                                          onClick={handleViewChangesClick}
                                        />&nbsp;&nbsp;

                                        <input type="button" id="edit-task-delete" name="" value="Delete" className="form-submit" onClick={handleDelete} />
                            </div>
                        </div>
                    </form>

                </div>
                </div>
}
            </div>
            <div className="right">
              {domainName === configData.RSMWW_DOMAIN && 
                <SalespersonSidebar/>
              } 
              {((domainName === configData.RSMWW_SCOUT_DOMAIN || domainName === configData.RSMWW_AGENCY_DOMAIN) && 
              (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) ? 
                (<SalespersonSidebar/>
                ) : (
                <>
                  <h1>Quick Links</h1>    
                  <ul className="user-opt-menu" style={{paddingLeft:"0px"}}>       
                    <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                    <li>
                      <a href="/smww_pay">
                        <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                      </a>
                    </li>
                  </ul>  
                </>
              )} 
            </div>
        </div>
            )}
            </>
    );
};
export default ResourceLibraryEdit;